import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Cómo encuentro un proveedor de SAINT® TMS?",
    answer:
      "SAINT® está autorizado por la FDA (K220177). Busque un proveedor que administre el protocolo completo con orientación por fMRI. [[Encuentre un proveedor verificado de SAINT®|/es/find-a-verified-saint-provider]] o llame al 954-827-9793.",
  },
  {
    question: "¿SAINT® está disponible cerca de mí?",
    answer:
      "SAINT® se ofrece en centros especializados. Neuro Wellness TMS Centers of America lo ofrece en Coral Springs, FL. [[Vea nuestra página de SAINT®|/es/saint]] o llame al 954-827-9793.",
  },
];

export const esHowToFindSaintProvider = makeEsArticle({
  slug: "how-to-find-a-saint-tms-provider",
  title: "Cómo encontrar un proveedor de SAINT® TMS | Neuro Wellness",
  description:
    "Cómo encontrar un proveedor de SAINT® TMS: protocolo autorizado por la FDA (K220177), orientación por fMRI y evaluación clínica de la idoneidad.",
  h1: "Cómo encontrar un proveedor de SAINT® TMS",
  breadcrumbLabel: "Encontrar un proveedor de SAINT®",
  shortAnswer:
    "SAINT® está autorizado por la FDA (K220177) para adultos cuya depresión no ha mejorado con antidepresivos. Para encontrar un proveedor, busque uno que administre el protocolo completo (orientación por fMRI, 50 sesiones en cinco días) y cuente con un equipo clínico que evalúe la idoneidad. [[Encuentre un proveedor verificado de SAINT®|/es/find-a-verified-saint-provider]] o llame al 954-827-9793.",
  keyTakeaways: [
    "SAINT® está autorizado por la FDA (K220177).",
    "El protocolo completo usa orientación por fMRI.",
    "Un equipo clínico evalúa la idoneidad.",
    "Verifique que el proveedor siga el protocolo completo.",
  ],
  sections: [
    {
      heading: "Dónde buscar",
      paragraphs: [
        "SAINT® se ofrece en centros especializados. Neuro Wellness TMS Centers of America lo ofrece en Coral Springs, FL. [[Vea nuestra página de SAINT®|/es/saint]] o llame al 954-827-9793.",
      ],
    },
    {
      heading: "Qué preguntar",
      paragraphs: [
        "Pregunte si el proveedor sigue el protocolo completo, incluida la orientación por fMRI. SAINT® está indicado para adultos con trastorno depresivo mayor que no han mejorado con antidepresivos.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);

export const esIsSaintAvailableNearMe = makeEsArticle({
  slug: "is-saint-available-near-me",
  title: "¿SAINT® está disponible cerca de mí? | Neuro Wellness",
  description:
    "SAINT® se ofrece en centros especializados. Neuro Wellness TMS Centers of America lo ofrece en Coral Springs, FL, para pacientes locales y de fuera del estado.",
  h1: "¿SAINT® está disponible cerca de mí?",
  breadcrumbLabel: "SAINT® cerca de mí",
  shortAnswer:
    "SAINT® se ofrece en centros especializados. Neuro Wellness TMS Centers of America lo ofrece en Coral Springs, FL. Atendemos a pacientes locales y de fuera del estado; el protocolo de cinco días hace que viajar sea práctico. [[Vea nuestra página de SAINT®|/es/saint]] o llame al 954-827-9793.",
  keyTakeaways: [
    "SAINT® se ofrece en centros especializados.",
    "Neuro Wellness lo ofrece en Coral Springs, FL.",
    "Atendemos a pacientes locales y de fuera del estado.",
    "El protocolo de cinco días hace que viajar sea práctico.",
  ],
  sections: [
    {
      heading: "Disponibilidad",
      paragraphs: [
        "SAINT® se ofrece en centros especializados. Neuro Wellness TMS Centers of America lo ofrece en Coral Springs, FL. Atendemos a pacientes locales y de fuera del estado.",
      ],
    },
    {
      heading: "Viajar para recibir SAINT®",
      paragraphs: [
        "El protocolo de cinco días hace que viajar sea práctico. [[Vea información sobre viajar para SAINT®|/es/saint-tms-travel]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
